<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
    <g fill="none" fill-rule="evenodd">
        <g fill="#000">
            <g>
                <path class="fill" d="M42.667 37.333c7.17 0 13.018 5.66 13.32 12.755l.013.579V56c0 1.473-1.194 2.667-2.667 2.667-1.367 0-2.494-1.03-2.648-2.356L50.667 56v-5.333c0-4.26-3.33-7.743-7.53-7.987l-.47-.013H21.333c-4.26 0-7.743 3.33-7.986 7.53l-.014.47V56c0 1.473-1.194 2.667-2.666 2.667-1.368 0-2.495-1.03-2.65-2.356L8 56v-5.333c0-7.17 5.66-13.019 12.755-13.321l.578-.013h21.334zM32 5.333c7.364 0 13.333 5.97 13.333 13.334C45.333 26.03 39.363 32 32 32c-7.364 0-13.333-5.97-13.333-13.333 0-7.364 5.97-13.334 13.333-13.334zm0 5.334c-4.418 0-8 3.581-8 8 0 4.418 3.582 8 8 8s8-3.582 8-8c0-4.419-3.582-8-8-8z" transform="translate(-642 -431) translate(642 431)"/>
            </g>
        </g>
    </g>
</svg>
